<template>
    <loading-indicator v-if="loading"/>
    <div v-else>
        <div v-if="active">
            <tab-bar-labels group="calendar-sync-device" param-name="device" class="no-padding">
                <tab-bar-label v-if="syncRunning || syncFinished" name="state" group="calendar-sync-device">Sync-Status</tab-bar-label>
                <tab-bar-label name="smartphone" group="calendar-sync-device">Smartphone</tab-bar-label>
                <tab-bar-label name="computer" group="calendar-sync-device">Computer</tab-bar-label>
            </tab-bar-labels>

            <tab-bar-content v-if="syncRunning || syncFinished" name="state" group="calendar-sync-device" class="default-padding text-center">
                <div v-if="syncFinished">
                    <i class="material-icons text-success md-72" aria-hidden="true" role="img">sync</i>
                    <br>
                    <br>
                    <strong class="color-primary">Kalender-Sync</strong>
                    <br>
                    <span>Der Kalender-Sync wurde erfolgreich eingerichtet.</span>
                    <br>
                    <br>
                </div>
                <loading-indicator v-else-if="syncRunning" text="Termine werden synchronisiert..." class="default-padding no-padding-top"/>
                <div>
                    <strong>Anleitungen:</strong> <a v-interact="() => showTutorial({device: 'smartphone', tab: 'android'})">Android</a> | <a
                    v-interact="() => showTutorial({device: 'computer', tab: 'google'})">Google Kalender</a> | <a
                    v-interact="() => showTutorial({device: 'smartphone', tab: 'ios'})">iOS</a> | <a v-interact="() => showTutorial({device: 'computer', tab: 'macos'})">macOS</a> |
                    <a v-interact="() => showTutorial({device: 'computer', tab: 'outlook', outlook: 'outlook'})">Outlook App</a> | <a
                    v-interact="() => showTutorial({device: 'computer', tab: 'outlook', outlook: 'outlook_plugin'})">Outlook Plugin</a> | <a
                    v-interact="() => showTutorial({device: 'computer', tab: 'thunderbird'})">Thunderbird</a>
                </div>
            </tab-bar-content>

            <tab-bar-content name="smartphone" group="calendar-sync-device">
                <tab-bar-labels group="calendar-sync" param-name="tab" :class="{'no-padding': isIos}">
                    <tab-bar-label name="android" group="calendar-sync">Android</tab-bar-label>
                    <tab-bar-label name="ios" group="calendar-sync">iOS</tab-bar-label>
                </tab-bar-labels>

                <tab-bar-content name="android" group="calendar-sync" class="default-padding no-padding-top">
                    <div class="row">
                        <div class="col-lg-12">
                            <strong>Anleitung: Android</strong>
                            <br>
                            <br>
                            Die Kalender-Synchronisation basiert auf dem CalDav-Protokoll. Bei „Android“ handelt es sich zudem um die Software eines Drittanbieters. Das bedeutet, dass wir keinen Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                            <br>
                            <br>
                            Wir Empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                            <br>
                            <br>
                            <div class="infobox infobox-border">
                                <strong>Hinweis:</strong>
                                <br>
                                Sie haben die Möglichkeit, Ihre {{calendarTitle}} auch in Ihren Android-Kalender zu importieren. Da Android standardisiert jedoch keinen CalDav-Sync. anbietet, benötigen Sie für die Synchronisation Ihrer Kalender eine zusätzliche App, für die ggf. Kosten anfallen können. Diese können Sie sich im Google Play Store herunterladen.
                            </div>
                            <br>
                            Wenn Sie dazu aufgefordert werden, den Link zum {{calendarTitle}} aus dem {{systemTitle}} anzugeben, verwenden Sie bitte folgenden Link:
                            <app-code>{{getCalDAVUrl('android')}}</app-code>
                            <br>
                        </div>
                    </div>
                </tab-bar-content>

                <tab-bar-content name="ios" group="calendar-sync">
                    <tab-bar-labels group="calendar-sync-ios" param-name="ios">
                        <tab-bar-label name="ios" group="calendar-sync-ios">Kalenderabonnement (lesend)</tab-bar-label>
                        <tab-bar-label name="ios_caldav" group="calendar-sync-ios">CalDAV-Account (schreibend)</tab-bar-label>
                    </tab-bar-labels>

                    <tab-bar-content name="ios" group="calendar-sync-ios" class="default-padding no-padding-top">
                        <div class="row">
                            <div class="col-lg-12">
                                <strong>Anleitung: iOS</strong>
                                <br>
                                <br>
                                Die Kalender-Synchronisation basiert auf dem iCalendar. Bei „iOS“ handelt es sich zudem um die Software eines Drittanbieters. Das bedeutet, dass wir keinen Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                                <br>
                                <br>
                                Wir Empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Sie haben die Möglichkeit, nach dem Verknüpfen Ihrer Kalender, die Termine jederzeit manuell in Ihrem iOS-Kalender zu aktualisieren. Gehen Sie dafür in den Eingang Ihres Kalenders und streichen Sie über die Liste nach unten.
                                </div>
                                <br>
                                1. Öffnen Sie Ihren iOS-Kalender, klicken Sie unten in Ihrem Menü auf „Kalender“ und dann auf „Hinzufügen“.
                                <br>
                                <img src="/img/calendar_sync/ios/ical/part_1.png" alt="Bild Kalender in iOS hinzufügen" v-light-box x-light-box="ios" style="max-width: 250px;">
                                <br>
                                <br>
                                2. Es öffnet sich nun ein Pop-up, wählen Sie „Kalenderabonnement hinzufügen“ aus.
                                <br>
                                <img src="/img/calendar_sync/ios/ical/part_2.png" alt="Bild Kalenderabonnement hinzufügen" v-light-box x-light-box="ios" style="max-width: 250px;">
                                <br>
                                <br>
                                3. Im neu geöffneten Fenster hinterlegen Sie den Link aus dem {{systemTitle}}:
                                <br>
                                <app-code>{{getCalDAVUrl('ical')}}</app-code>
                                <br>
                                <img src="/img/calendar_sync/ios/ical/part_3.png" alt="Bild Link einfügen" v-light-box x-light-box="ios" style="max-width: 250px;">
                                <br>
                                <br>
                                4. Klicken Sie im Anschluss auf „Abonnieren“.
                                <br>
                                <img src="/img/calendar_sync/ios/ical/part_4.png" alt="Bild Kalender abonnieren" v-light-box x-light-box="ios">
                                <br>
                                <br>
                                5. Tragen Sie im nächsten Schritt Ihre <strong>E-Mail-Adresse</strong> sowie Ihr
                                <strong>Passwort</strong> für das {{systemTitle}} ein. Drücken Sie dann auf das Feld „OK“.
                                <br>
                                <img src="/img/calendar_sync/ios/ical/part_5.png" alt="Bild E-Mail-Adresse und Passwort eintragen" v-light-box x-light-box="ios"
                                    style="max-width: 250px;">
                                <br>
                                <br>
                                6. Drücken Sie abschließend auf das Feld „Hinzufügen“. Ihr Kalender aus dem {{systemTitle}} wird nun in Ihrem iOS-Kalender angezeigt.
                                <br>
                                <img src="/img/calendar_sync/ios/ical/part_6.png" alt="Bild Kalender hinzufügen" v-light-box x-light-box="ios" style="max-width: 250px;">
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Um weitere Kalender aus Ihrem {{systemTitle}} in Ihren iOS-Kalender zu importieren, wiederholen Sie die Schritte 1-6 für jeden einzelnen Kalender erneut.
                                </div>
                            </div>
                        </div>
                    </tab-bar-content>

                    <tab-bar-content name="ios_caldav" group="calendar-sync-ios" class="default-padding no-padding-top">
                        <div class="row">
                            <div class="col-lg-12">
                                <strong>Anleitung: iOS (CalDAV-Account)</strong>
                                <br>
                                <br>
                                Die Kalender-Synchronisation basiert auf dem CalDav-Protokoll. In diesem Fall werden die im iOS-Kalender bearbeiteten Termine auch in den {{calendarTitle}} übertragen. Apple bietet jedoch
                                keine Möglichkeit an, nur einzelne Kalender zu synchronisieren, weshalb alle aktiven Kalender auch
                                im iOS-Kalender angezeigt werden.
                                <br>
                                <br>
                                Bei „iOS“ handelt es sich zudem um die Software eines Drittanbieters. Das bedeutet, dass wir keinen
                                Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                                <br>
                                <br>
                                Wir Empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Sie haben die Möglichkeit, nach dem Verknüpfen Ihrer Kalender, die Termine jederzeit
                                    manuell in Ihrem iOS-Kalender zu aktualisieren. Gehen Sie dafür in den Eingang Ihres Kalenders und
                                    streichen Sie über die Liste nach unten.
                                </div>
                                <br>
                                1. Öffnen Sie die Geräte Einstellungen und klicken Sie danach zunächst auf „Mail“, wählen Sie
                                dann „Accounts“ aus und klicken Sie auf „Account hinzufügen“.
                                <br>
                                <img src="/img/calendar_sync/ios/caldav/part_1.jpg" alt="Bild Account hinzufügen" v-light-box x-light-box="ios_caldav" style="max-width: 250px;">
                                <br>
                                <br>
                                2. Es öffnet sich ein neues Fenster, klicken Sie nun auf „Andere“.
                                <br>
                                <img src="/img/calendar_sync/ios/caldav/part_2.jpg" alt="Bild Account-Typ wählen" v-light-box x-light-box="ios_caldav" style="max-width: 250px;">
                                <br>
                                <br>
                                3. Es öffnet sich wieder ein neues Fenster, klicken Sie hier auf „CalDAV-Account hinzufügen“.
                                <br>
                                <img src="/img/calendar_sync/ios/caldav/part_3.jpg" alt="Bild CalDAV-Account hinzufügen" v-light-box x-light-box="ios_caldav"
                                    style="max-width: 250px;">
                                <br>
                                <br>
                                4. Geben Sie folgende Daten ein:
                                <br>
                                <strong>Server:</strong> Hinterlegen Sie hier folgenden Link aus dem {{systemTitle}}:
                                <br>
                                <app-code>{{getCalDAVUrl('ios_caldav')}}</app-code>
                                <br>
                                <strong>Benutzername:</strong> Geben Sie hier die E-Mail-Adresse ein, die Sie zum Login für Ihr
                                {{systemTitle}} verwenden.
                                <br>
                                <strong>Passwort:</strong> Geben Sie hier das Passwort ein, welches Sie zum Login für Ihr
                                {{systemTitle}} verwenden.
                                <br>
                                <img src="/img/calendar_sync/ios/caldav/part_4.jpg" alt="Bild CalDAV-Accountdaten eingeben" v-light-box x-light-box="ios_caldav"
                                    style="max-width: 250px;">
                                <br>
                                <br>
                                5. Es öffnet sich ein Pop-up. Legen Sie fest, ob Sie Kalender und Erinnerungen nutzen wollen
                                und klicken Sie dann auf „Sichern“. Der Kalender wird nun aus dem {{systemTitle}} in
                                Ihren iOS-Kalender übertragen.
                                <br>
                                <img src="/img/calendar_sync/ios/caldav/part_5.jpg" alt="Bild CalDAV-Account hinzufügen" v-light-box x-light-box="ios_caldav"
                                    style="max-width: 250px;">
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Wenn Sie weitere Kalender aus Ihrem {{systemTitle}} in Ihren iOS-Kalender importieren
                                    möchten, müssen Sie im {{systemTitle}} den gewünschten Kalender öffnen und diesen über das
                                    Drei-Punkte-Menü aktivieren. Nach Abschluss des Imports wird der aus dem {{systemTitle}}
                                    ausgewählte Kalender dann automatisch in Ihrem iOS-Kalender angezeigt. Es ist nicht erforderlich,
                                    einen weiteren CalDAV-Account hinzuzufügen.
                                </div>
                            </div>
                        </div>
                    </tab-bar-content>
                </tab-bar-content>
            </tab-bar-content>

            <tab-bar-content name="computer" group="calendar-sync-device">
                <tab-bar-labels group="calendar-sync" param-name="tab" :class="{'no-padding': isOutlook}">
                    <tab-bar-label name="google" group="calendar-sync"> Google Kalender</tab-bar-label>
                    <tab-bar-label name="macos" group="calendar-sync"> macOS</tab-bar-label>
                    <tab-bar-label name="outlook" group="calendar-sync">Outlook</tab-bar-label>
                    <tab-bar-label name="thunderbird" group="calendar-sync">Thunderbird</tab-bar-label>
                    <tab-bar-label name="other" group="calendar-sync">Sonstige</tab-bar-label>
                </tab-bar-labels>

                <tab-bar-content name="google" group="calendar-sync" class="default-padding no-padding-top">
                    <loading-indicator v-if="syncRunning" text="Termine werden synchronisiert..." class="default-padding no-padding-top"/>
                    <loading-indicator v-else-if="googleLoading"/>
                    <div v-else>
                        <strong>Anleitung: Google Kalender</strong>
                        <br>
                        <br>
                        Der im Google Kalender eigebundene Kalender wird laut Angaben von Google nur alle 24 Stunden
                        aktualisiert. Weder die manuelle Aktualisierung noch die Einstellung des Aktualisierungsintervalls
                        sind möglich.
                        <br>
                        <br>
                        <div class="infobox infobox-border">
                            <strong>Hinweis:</strong>
                            <br>
                            Sie haben die Möglichkeit, nach dem Verknüpfen Ihrer Kalender, die Termine jederzeit manuell in Outlook zu aktualisieren. Klicken Sie dafür oben in der Menüleiste auf „Alle Ordner senden/empfangen“.
                        </div>
                        <br>
                        1. Öffnen Sie sich Ihren Google Kalender und wählen Sie <strong>Weitere Kalender hinzufügen</strong> aus,
                        indem Sie mit der linken Maustaste auf das <strong>Plus</strong> klicken.
                        <br>
                        <img src="/img/calendar_sync/google/part_1.jpg" alt="Bild Weitere Kalender hinzufügen" v-light-box x-light-box="google">
                        <br>
                        <br>
                        2. Klicken Sie dann auf „Per URL“.
                        <br>
                        <img src="/img/calendar_sync/google/part_2.jpg" alt="Bild Weitere Kalender per URL hinzufügen" v-light-box x-light-box="google">
                        <br>
                        <br>
                        3. Es öffnet sich nun die Eingabemöglichkeit für die URL, hinterlegen Sie hier folgenden Link aus dem {{systemTitle}}:
                        <br>
                        <div v-if="googleToken">
                            <app-code>{{getCalDAVUrl('google')}}</app-code>
                            <br>
                            <div v-interact="generateGoogleToken" class="button button-success">
                                <i class="material-icons" aria-hidden="true" role="img">add_link</i>
                                <span>Google-Link neu generieren</span>
                            </div>
                            <br>
                            <div v-interact="resetGoogleToken" class="button button-danger">
                                <i class="material-icons" aria-hidden="true" role="img">link_off</i>
                                <span>Google-Link löschen</span>
                            </div>
                        </div>
                        <div v-else v-interact="generateGoogleToken" class="button button-success">
                            <i class="material-icons" aria-hidden="true" role="img">add_link</i>
                            <span>Google-Link generieren</span>
                        </div>
                        <br>
                        <img src="/img/calendar_sync/google/part_3.jpg" alt="Bild URL hinterlegen" v-light-box x-light-box="google">
                        <br>
                        <br>
                        4. Klicken Sie anschließend auf „Kalender hinzufügen“.
                        <br>
                        <img src="/img/calendar_sync/google/part_4.jpg" alt="Bild Kalender hinzufügen" v-light-box x-light-box="google">
                        <br>
                        <br>
                        <div class="infobox infobox-border">
                            <strong>Hinweis:</strong>
                            <br>
                            Um weitere Kalender aus Ihrem {{systemTitle}} in Ihren Google-Kalender zu importieren, wiederholen Sie die Schritte 1-4 für jeden einzelnen Kalender erneut.
                        </div>
                    </div>
                </tab-bar-content>

                <tab-bar-content name="macos" group="calendar-sync" class="default-padding no-padding-top">
                    <div class="row">
                        <div class="col-lg-12">
                            <strong>Anleitung: macOS</strong>
                            <br>
                            <br>
                            Die Kalender-Synchronisation basiert auf dem CalDav-Protokoll. Bei „macOS“ handelt es sich zudem um die Software eines Drittanbieters. Das bedeutet, dass wir keinen Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                            <br>
                            <br>
                            Wir Empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                            <br>
                            <br>
                            1. Öffnen Sie Ihren <strong>Apple Kalender</strong>.
                            <br>
                            <br>
                            2. Klicken Sie oben in der Werkzeugleiste auf „Kalender“ und dann auf „Einstellungen“.
                            <br>
                            <img src="/img/calendar_sync/macos/part_1.png" alt="Bild Einstellungen öffnen" v-light-box x-light-box="macos">
                            <br>
                            <br>
                            3. Klicken Sie auf den „Accounts-Reiter“.
                            <br>
                            <br>
                            4. Klicken Sie auf den „+-Button“ im Konten-Fenster links.
                            <br>
                            <img src="/img/calendar_sync/macos/part_2.png" alt="Bild Account hinzufügen" v-light-box x-light-box="macos" style="max-width: 325px;">
                            <br>
                            <br>
                            5. Wählen Sie „anderer CalDAV-Account hinzufügen...“.
                            <br>
                            <br>
                            6. Wählen Sie „Manuell“ als Account-Typ.
                            <br>
                            <br>
                            7. Geben Sie folgende Daten ein:
                            <br>
                            <br>
                            <strong>Account-Typ:</strong> Manuell
                            <br>
                            <strong>Benutzername:</strong> Geben Sie hier die E-Mail-Adresse ein, die Sie zum Login für Ihr {{systemTitle}} verwenden.
                            <br>
                            <strong>Passwort:</strong> Geben Sie hier das Passwort ein, welches Sie zum Login für Ihr {{systemTitle}} verwenden.
                            <br>
                            <strong>Server-Adresse:</strong> Hinterlegen Sie hier folgenden Link aus dem {{systemTitle}}:
                            <br>
                            <app-code>{{getCalDAVUrl('macos', 1)}}</app-code>
                            <br>
                            <img src="/img/calendar_sync/macos/part_3.png" alt="Bild CalDAV-Account Daten eingeben" v-light-box x-light-box="macos">
                            <br>
                            <br>
                            8. Klicken Sie auf „Anmelden“. Der Kalender wird nun aus dem {{systemTitle}} in Ihren macOS Kalender übertragen.
                            <br>
                            <br>
                            <div class="infobox infobox-border">
                                <strong>Hinweis:</strong>
                                <br>
                                Wenn Sie weitere Kalender aus Ihrem {{systemTitle}} in Ihren macOS Kalender importieren möchten, müssen Sie im {{systemTitle}} den gewünschten Kalender öffnen und diesen über das Drei-Punkte-Menü aktivieren. Nach Abschluss des Imports wird der aus dem {{systemTitle}} ausgewählte Kalender dann automatisch in Ihrem macOS Kalender angezeigt. Es ist nicht erforderlich, einen weiteren CalDAV-Account hinzuzufügen.
                            </div>
                        </div>
                    </div>
                </tab-bar-content>

                <tab-bar-content name="outlook" group="calendar-sync">
                    <tab-bar-labels group="calendar-sync-outlook" param-name="outlook">
                        <tab-bar-label name="outlook" group="calendar-sync-outlook">Outlook App</tab-bar-label>
                        <tab-bar-label name="outlook_plugin" group="calendar-sync-outlook">Outlook Plugin</tab-bar-label>
                    </tab-bar-labels>

                    <tab-bar-content name="outlook" group="calendar-sync-outlook" class="default-padding no-padding-top">
                        <div class="row">
                            <div class="col-lg-12">
                                <strong>Anleitung: Outlook App-Version 2208 Build 15601.20148</strong>
                                <br>
                                <br>
                                Die Kalender-Synchronisation basiert auf dem iCalendar. Bei „Outlook“ handelt es sich zudem um die Software eines Drittanbieters. Das bedeutet, dass wir keinen Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                                <br>
                                <br>
                                Wir Empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Sie haben die Möglichkeit, nach dem Verknüpfen Ihrer Kalender, die Termine jederzeit manuell in Outlook zu aktualisieren. Klicken Sie dafür oben in der Menüleiste auf „Alle Ordner senden/empfangen“.
                                </div>
                                <br>
                                1. Öffnen Sie Ihre Outlook-App und wählen Sie die <strong>Kalenderansicht</strong> aus.
                                <br>
                                <br>
                                2. Klicken Sie mit Ihrer rechten Maustaste auf „Meine Kalender“.
                                <br>
                                <img src="/img/calendar_sync/outlook/part_1.png" alt="Bild Optionen zu Meine Kalender" v-light-box x-light-box="outlook">
                                <br>
                                <br>
                                Es öffnet sich ein Pop-up. Klicken Sie auf „Kalender hinzufügen“. Klicken Sie dann im neu geöffneten Pop-up auf „Aus dem Internet“.
                                <img src="/img/calendar_sync/outlook/part_2.png" alt="Bild Kalender aus dem Internet hinzufügen" v-light-box x-light-box="outlook"
                                    style="max-width: 400px;">
                                <br>
                                <br>
                                3. Es öffnet sich ein neues Fenster, hinterlegen Sie hier folgenden Link aus dem {{systemTitle}}:
                                <app-code>{{getCalDAVUrl('ical')}}</app-code>
                                <br>
                                4. Klicken Sie anschließend auf „OK“.
                                <img src="/img/calendar_sync/outlook/part_3.png" alt="Bild Link einfügen" v-light-box x-light-box="outlook" style="max-width: 400px;">
                                <br>
                                <br>
                                5. Es öffnet sich nun ein weiteres Fenster. Tragen Sie dort Ihre {{systemTitle}} <strong>E-Mail-Adresse</strong> und Ihr
                                <strong>Passwort</strong> ein und klicken Sie auf „OK“.
                                <img src="/img/calendar_sync/outlook/part_4.png" alt="Bild E-Mail-Adresse und Passwort eingeben" v-light-box x-light-box="outlook"
                                    style="max-width: 400px;">
                                <br>
                                <br>
                                6. Klicken Sie im neu geöffneten Fenster auf „Ja“, um Ihren {{calendarTitle}} in Ihren Outlook-Kalender zu importieren.
                                <br>
                                <img src="/img/calendar_sync/outlook/part_5.png" alt="Bild Kalender in Outlook importieren" v-light-box x-light-box="outlook"
                                    style="max-width: 400px;">
                                <br>
                                <br>
                                7. Bitte beachten Sie, dass die Voreinstellung für automatische Übermittlungen in Outlook "alle 30 Minuten" beträgt. Um die Voreinstellung anzupassen öffnen Sie die Outlook-Optionen und tragen Sie im Menüpunkt "Erweitert" unter "Senden-Empfangen-Gruppe" bei der automatischen Übermittlung ein, in welchem Rythmus Ihr Kalender aktualisiert werden soll.
                                <img src="/img/calendar_sync/outlook/part_6.png" alt="Bild Kalender in Outlook importieren" v-light-box x-light-box="outlook"
                                    style="max-width: 400px;">
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Um weitere Kalender aus Ihrem {{systemTitle}} in Ihren Outlook-Kalender zu importieren, wiederholen Sie die Schritte 1-7 für jeden einzelnen Kalender erneut.
                                </div>
                            </div>
                        </div>
                    </tab-bar-content>

                    <tab-bar-content name="outlook_plugin" group="calendar-sync-outlook" class="default-padding no-padding-top">
                        <div class="row">
                            <div class="col-lg-12">
                                <strong>Anleitung: Outlook-Plugin für eine schreibende Schnittstelle</strong>
                                <br>
                                <br>
                                Die Kalender-Synchronisation basiert auf dem CalDav-Protokoll. Bei „Outlook“ und „Outlook CalDav Synchronizer" handelt es sich um Software von Drittanbietern. Das bedeutet, dass wir keinen Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                                <br>
                                <br>
                                Wir empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen, ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                                <br>
                                <br>
                                <div class="infobox infobox-border">
                                    <strong>Hinweis:</strong>
                                    <br>
                                    Sie haben die Möglichkeit, Ihre Kalender über ein Plugin mit Ihrem Outlook zu verknüpfen. Durch die Nutzung eines Plugins wird Ihnen eine schreibende Schnittstelle zur Verfügung gestellt.
                                </div>
                                <br>
                                Ein solches Plugin finden Sie beispielsweise unter <a href="https://caldavsynchronizer.org/de/" target="_blank"
                                aria-label="Link zum CalDAV-Synchronizer Plugin">https://caldavsynchronizer.org</a>.
                                <br>
                                <br>
                                Wenn Sie dazu aufgefordert werden, den Link zum Kalender anzugeben, verwenden Sie bitte folgenden Link:
                                <app-code>{{getCalDAVUrl('outlook_plugin')}}</app-code>
                                <br>
                            </div>
                        </div>
                    </tab-bar-content>
                </tab-bar-content>

                <tab-bar-content name="thunderbird" group="calendar-sync" class="default-padding no-padding-top">
                    <div class="row">
                        <div class="col-lg-12">
                            <strong>Anleitung: Thunderbird</strong>
                            <br>
                            <br>
                            Die Kalender-Synchronisation basiert auf dem CalDav-Protokoll. Bei „Thunderbird“ handelt es sich zudem um die Software eines Drittanbieters. Das bedeutet, dass wir keinen Einfluss auf Änderungen, Updates oder die Funktionen der Programme haben.
                            <br>
                            <br>
                            Wir Empfehlen vor der Durchführung der Kalendersynchronisation zu überprüfen ob Sie die derzeit aktuellste Version Ihres Kalenderprogramms installiert haben.
                            <br>
                            <br>
                            <div class="infobox infobox-border">
                                <strong>Hinweis:</strong>
                                <br>
                                Sie haben die Möglichkeit, nach dem Verknüpfen Ihrer Kalender, die Termine jederzeit manuell in Thunderbird zu aktualisieren. Klicken Sie dafür oben in der Menüleiste über Ihrem Kalender auf „Synchronisieren“.
                            </div>
                            <br>
                            1. Öffnen Sie in Thunderbird Ihren Kalender. Dort haben Sie die Option einen weiteren Kalender hinzuzufügen. Klicken Sie dafür auf den
                            <strong>+</strong>-Button rechts unter dem Kalender.
                            <br>
                            <img src="/img/calendar_sync/thunderbird/part_1.png" alt="Bild Kalender hinzufügen" v-light-box x-light-box="thunderbird">
                            <br>
                            <br>
                            2. Es öffnet sich nun das Fenster „Neuen Kalender erstellen“. Klicken Sie dort auf <strong>„Im Netzwerk“</strong> und dann auf „Nächste“.
                            <br>
                            <img src="/img/calendar_sync/thunderbird/part_2.png" alt="Bild Kalender aus dem Netzwerk hinzufügen" v-light-box x-light-box="thunderbird"
                                style="max-width: 400px;">
                            <br>
                            <br>
                            3. Geben Sie folgende Daten im neu geöffneten Fenster ein und klicken Sie abschließend auf „Kalender suchen“:
                            <br>
                            <br>
                            <strong>Benutzername:</strong> Geben Sie hier die E-Mail-Adresse ein, die Sie zum Login für Ihr {{systemTitle}} verwenden.
                            <br>
                            <strong>Adresse:</strong> Hinterlegen Sie hier folgenden Link aus dem {{systemTitle}}:
                            <app-code>{{getCalDAVUrl('thunderbird')}}</app-code>
                            <br>
                            <img src="/img/calendar_sync/thunderbird/part_3.png" alt="Bild E-Mail-Adresse und Adresse eingeben" v-light-box x-light-box="thunderbird"
                                style="max-width: 400px;">
                            <br>
                            <br>
                            4. Es öffnet sich nun ein weiteres Fenster. Tragen Sie dort Ihr <strong>{{systemTitle}}-Passwort</strong> ein und klicken Sie auf „OK“.
                            <br>
                            <img src="/img/calendar_sync/thunderbird/part_4.png" alt="Bild Passwort eingeben" v-light-box x-light-box="thunderbird" style="max-width: 400px;">
                            <br>
                            <br>
                            5. Klicken Sie auf „Abonnieren“, um Ihren {{calendarTitle}} in Ihren Thunderbird-Kalender zu importieren.
                            <br>
                            <img src="/img/calendar_sync/thunderbird/part_5.png" alt="Bild Kalender importieren" v-light-box x-light-box="thunderbird" style="max-width: 400px;">
                            <br>
                            <br>
                            <div class="infobox infobox-border">
                                <strong>Hinweis:</strong>
                                <br>
                                Um weitere Kalender aus Ihrem {{systemTitle}} in Ihren Thunderbird-Kalender zu importieren, wiederholen Sie die Schritte 1-5 für jeden einzelnen Kalender erneut.
                            </div>
                        </div>
                    </div>
                </tab-bar-content>

                <tab-bar-content name="other" group="calendar-sync" class="default-padding no-padding-top">
                    <div>
                        <strong>Anleitung: Sonstige</strong>
                        <br>
                        <br>
                        <div class="infobox infobox-border">
                            <strong>Hinweis:</strong>
                            <br>
                            Es gibt verschiedene Programme, die grundsätzlich eine CalDAV-Schnittstelle unterstützen. Suchen Sie in Ihrem Programm oder fragen Sie bei Ihrem Anbieter nach der Funktionalität, eine Termin-Synchronisation einzurichten bzw. eine CalDAV-Schnittstelle zu aktivieren.
                            <br>
                        </div>
                        <br>
                        Wenn Sie dazu aufgefordert werden, den Link zum {{calendarTitle}} aus dem {{systemTitle}} anzugeben, verwenden Sie bitte folgenden Link:
                        <app-code>{{getCalDAVUrl('other')}}</app-code>
                        <br>
                    </div>
                </tab-bar-content>
            </tab-bar-content>
        </div>
        <div v-else>
            Möchten Sie den Kalender-Sync für den Kalender <strong>"{{title}}"</strong> aktivieren?
            <br>
            <br>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import axios from 'axios';
    import type {TinyEmitter} from 'tiny-emitter';
    import AppCode from '../../components/AppCode.vue';
    import LoadingIndicator from '../../components/LoadingIndicator.vue';
    import TabBarContent from '../../components/TabBarContent.vue';
    import TabBarLabel from '../../components/TabBarLabel.vue';
    import TabBarLabels from '../../components/TabBarLabels.vue';
    import {popupDefaultCancelButton, popupDefaultCloseButton} from '../../library/popup';
    import TopMessageHandler from '../../library/topMessageHandler';
    import {errorHandler} from '@/utils/portuna';
    import {useStore} from 'vuex';
    import {computed, inject, ref, toRefs} from 'vue';

    const popupEmitter = inject<TinyEmitter>('popup-emitter')!;
    const portuna      = usePortuna();

    type TabShow = {
        device: 'state' | 'smartphone' | 'computer';
        tab?: 'android' | 'ios' | 'google' | 'macos' | 'outlook' | 'thunderbird' | 'other';
        ios?: 'ios' | 'ios_caldav';
        outlook?: 'outlook' | 'outlook_plugin';
    };

    const emit = defineEmits<{
        setData: [...args: unknown[]];
    }>();

    const props = defineProps<{
        resource: string;
        id: number;
    }>();

    const {
              id,
              resource,
          } = toRefs(props);

    const store = useStore();

    const active        = ref(false);
    const email         = ref('');
    const title         = ref('');
    const loading       = ref(true);
    const syncRunning   = ref(false);
    const syncFinished  = ref(false);
    const googleToken   = ref<Nullable<string>>(null);
    const googleLoading = ref(false);
    const interval      = ref(0);

    const tabBar = computed<Record<string, TabBarData>>(() => store.state.tabBar);

    const isOutlook = computed(() =>
    {
        if (!tabBar.value || !tabBar.value['calendar-sync'])
        {
            return false;
        }
        return tabBar.value['calendar-sync'].active === 'outlook';
    });

    const isIos = computed(() =>
    {
        if (!tabBar.value || !tabBar.value['calendar-sync'])
        {
            return false;
        }
        return tabBar.value['calendar-sync'].active === 'ios';
    });

    const isServices = computed(() =>
    {
        return 'services' === resource.value!;
    });

    const getCalDAVUrl = (type: string, part: Nullable<number> = null) =>
    {
        let urlParts = ['https://', location.host, 'caldav'];
        if ('macos' === type)
        {
            if (null !== part)
            {
                return (2 === part ? '/' : '') + urlParts[part];
            }

            return urlParts[0] + urlParts[1] + '/' + urlParts[2];
        }

        urlParts[2] += `/calendars/${email.value}/${resource.value!}-${id.value!}`;

        if ('ical' === type || 'google' === type)
        {
            urlParts[2] += '?export';
            if ('google' === type)
            {
                urlParts[2] += '&gtoken=' + googleToken.value;
            }
        }
        else if (0 !== part)
        {
            urlParts[2] += '/';
        }
        if (null !== part)
        {
            return (2 === part ? '/' : '') + urlParts[part];
        }

        return urlParts[0] + urlParts[1] + '/' + urlParts[2];
    };

    const showTutorial = (tab: TabShow) =>
    {
        store.commit('updateTabBar', {
            group: 'calendar-sync-device',
            data: Object.assign({}, store.state.tabBar['calendar-sync-device'], {active: tab.device}),
        });

        if (tab.tab)
        {
            store.commit('updateTabBar', {
                group: 'calendar-sync',
                data: Object.assign({}, store.state.tabBar['calendar-sync'], {active: tab.tab}),
            });
        }

        if (tab.ios)
        {
            store.commit('updateTabBar', {
                group: 'calendar-sync-ios',
                data: Object.assign({}, store.state.tabBar['calendar-sync-ios'], {active: tab.ios}),
            });
        }
        else if (tab.outlook)
        {
            store.commit('updateTabBar', {
                group: 'calendar-sync-outlook',
                data: Object.assign({}, store.state.tabBar['calendar-sync-outlook'], {active: tab.outlook}),
            });
        }
    };

    const generateGoogleToken = () =>
    {
        googleLoading.value = true;

        axios
        .get(`/${resource.value!}/calendar/generate-caldav-google-token`)
        .then(({data: {data}}) =>
        {
            googleToken.value = data.caldav_google_token;

            TopMessageHandler.success('Der Google-Link wurde erfolgreich erstellt.');
        })
        .catch(errorHandler)
        .finally(() =>
        {
            googleLoading.value = false;
        });
    };

    const resetGoogleToken = () =>
    {
        googleLoading.value = true;
        axios
        .get(`/${resource.value!}/calendar/reset-caldav-google-token`)
        .then(() =>
        {
            googleToken.value = null;

            TopMessageHandler.success('Der Google-Link wurde erfolgreich gelöscht.');
        })
        .catch(errorHandler)
        .finally(() =>
        {
            googleLoading.value = false;
        });
    };

    const calendarTitle = computed(() =>
    {
        return `${isServices.value ? 'Terminbuchungs-' : 'Intranet-'}Kalender`;
    });

    const systemTitle = computed(() =>
    {
        return isServices.value ? 'Terminbuchungstool' : 'Intranet';
    });

    const buttons = computed(() =>
    {
        let buttons: PopupButton[] = [];
        if (active.value)
        {
            buttons.push(popupDefaultCloseButton);
            buttons.push({
                type: 'danger',
                title: 'Kalender-Sync deaktivieren',
                icon: 'delete',
                cmd: () => changeStatus(0),
            });
        }
        else
        {
            buttons.push(popupDefaultCancelButton);
            buttons.push({
                type: 'success',
                title: 'Kalender-Sync aktivieren',
                icon: 'sync',
                cmd: () => changeStatus(1),
            });
        }

        return buttons;
    });

    popupEmitter.emit('setData', {_alwaysShowScrollBar: true});

    const fetch = () =>
    {
        axios
        .get(`/${resource.value!}/calendar/fetch-caldav-sync/id/${id.value!}`)
        .then(({data: {data}}) =>
        {
            active.value      = data.active;
            email.value       = data.email;
            title.value       = data.title;
            syncRunning.value = data.sync_running;
            googleToken.value = data.caldav_google_token;

            if (interval.value && !syncRunning.value)
            {
                syncFinished.value = true;

                window.clearInterval(interval.value);

                interval.value = 0;
            }
            else if (syncRunning.value)
            {
                startSyncInterval();
            }
            else
            {
                showTutorial({
                    device: 'computer',
                    tab: 'thunderbird',
                });
            }

            popupEmitter.emit(
                'emit',
                {
                    event: 'setActive',
                    data: data.active,
                },
            );

            popupEmitter.emit('setButtons', buttons.value);
        })
        .finally(() =>
        {
            loading.value = false;

            popupEmitter.emit('lazy-load-focus');
        });
    };

    const changeStatus = (type: 0 | 1) =>
    {
        loading.value = true;

        popupEmitter.emit('setButtons', [popupDefaultCancelButton]);

        axios
        .post(`/${resource.value!}/calendar/change-caldav-sync-status/id/${id.value!}`, {type})
        .then(() =>
        {
            TopMessageHandler.success(
                `Der Kalender-Sync für den Kalender "${title.value}" wurde erfolgreich ${type ? '' : 'de'}aktiviert.   `,
            );

            active.value = !!type;

            popupEmitter.emit(
                'emit',
                {
                    event: 'setActive',
                    data: active.value,
                },
            );

            popupEmitter.emit('setButtons', buttons.value);

            if (active.value)
            {
                syncRunning.value  = true;
                syncFinished.value = false;

                startSyncInterval();
            }
            else if (interval.value)
            {
                syncRunning.value  = false;
                syncFinished.value = false;

                window.clearInterval(interval.value);

                interval.value = 0;
            }
        })
        .catch((error) =>
        {
            errorHandler(error);

            popupEmitter.emit('close');
        })
        .finally(() =>
        {
            loading.value = false;

            popupEmitter.emit('lazy-load-focus');
        });
    };

    const startSyncInterval = () =>
    {
        if (interval.value)
        {
            return;
        }

        interval.value = window.setInterval(() => fetch(), 5000);

        showTutorial({device: 'state'});
    };

    fetch();

    defineExpose(Object.assign({}, portuna));
</script>